import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const covarianceDescription: CalculatorDescription = {
  id: CalculatorId.COVARIANCE,
  title: 'Covariance Calculator',
  metaTitle: 'Online Covariance Calculator - Measure Variable Relationships',
  description: 'Calculate covariance to measure how two variables change together. Analyze the direction and magnitude of relationships between paired measurements.',
  metaDescription: 'Calculate covariance online. Measure how variables change together with our free calculator. Analyze relationships between paired measurements.',
  howTo: {
    title: 'How to Use the Covariance Calculator',
    steps: [
      'Enter paired data values for two variables',
      'Select the first (X) and second (Y) variables',
      'View the covariance value and means',
      'Interpret the direction of the relationship',
      'Visualize the relationship in the scatter plot'
    ],
    graphic: {
      description: 'A scatter plot showing the relationship between variables with covariance value and means'
    }
  },
  examples: [
    {
      title: 'Temperature and Sales',
      description: 'Analyzing relationship between temperature and ice cream sales',
      dataDescription: 'Daily temperature readings and corresponding sales figures',
      insights: [
        'Shows directional relationship',
        'Measures joint variation',
        'Indicates movement patterns',
        'Guides business planning'
      ]
    },
    {
      title: 'Economic Indicators',
      description: 'Analyzing relationship between economic variables',
      dataDescription: 'Monthly GDP and employment rate data',
      insights: [
        'Measures economic relationships',
        'Shows variable movements',
        'Indicates market patterns',
        'Supports economic analysis'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.CORRELATION_COEFFICIENT,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN
  ]
}; 